<template>
  <el-row class="container">
    <el-row style="text-align: left;padding: 0.1rem 0.32rem;border-bottom: 1px solid blue">
      案件详情
    </el-row>
    <el-row class="content">
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          案件名称 :
        </el-col>
        <el-col :span="17">{{ formCase.title }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          案件编号 :
        </el-col>
        <el-col :span="17">{{ formCase.caseNo }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          VIN :
        </el-col>
        <el-col :span="17">{{ formCase.vin }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          车&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型 :
        </el-col>
        <el-col :span="17">{{ formCase.vehicleType }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          车型代码 :
        </el-col>
        <el-col :span="17">{{ formCase.vehicleCode }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          发动机型号 :
        </el-col>
        <el-col :span="17">{{ formCase.engineModel }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          行驶里程 :
        </el-col>
        <el-col :span="17">{{ formCase.drivenDistance }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          下线日期 :
        </el-col>
        <el-col :span="17">{{ formCase.offlineDate }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          部位选择 :
        </el-col>
        <el-col :span="17">{{ formCase.parts }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          现象分类 :
        </el-col>
        <el-col :span="17">{{ formCase.phenomenons }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg"  v-if="formCase.dtcint == '有'">
        <el-col :span="7">
          DTC :
        </el-col>
        <el-col :span="17">{{ formCase.dtc }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          三包状态 :
        </el-col>
        <el-col :span="17">{{ formCase.warrantyPeriod }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          类型 :
        </el-col>
        <el-col :span="17">{{ formCase.kubun }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          故障时间 :
        </el-col>
        <el-col :span="17">{{ formCase.doneDatetime }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          提交时间 :
        </el-col>
        <el-col :span="17">{{ formCase.startDatetime }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="12">
          最终对应方案提出时间 :
        </el-col>
        <el-col :span="12" v-html="formCase.finalSolutionDate"></el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          结案时间 :
        </el-col>
        <el-col :span="17" v-html="formCase.doneDate"></el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          提交者 :
        </el-col>
        <el-col :span="17">{{ formCase.dealerCode }}-{{formCase.dealerName}}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          NTL :
        </el-col>
        <el-col :span="17">{{ formCase.relayusername }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg" v-if="formCase.type == 1">
        <el-col :span="7">
          CR苦情 :
        </el-col>
        <el-col :span="17">{{ formCase.complain }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg" v-if="formCase.type == 2">
        <el-col :span="7">
          顾客描述 :
        </el-col>
        <el-col :span="17">{{ formCase.customerConsultation }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg" v-if="formCase.type == 2">
        <el-col :span="7">
          现象确认 :
        </el-col>
        <el-col :span="17">{{ formCase.phenomenonConfirmation }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          检查内容 :
        </el-col>
        <el-col :span="17">{{ formCase.inspectionDiagnosis }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          请求支援内容:
        </el-col>
        <el-col :span="17">{{ formCase.supportDiagnosis }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          状态 :
        </el-col>
        <el-col :span="17">{{ formCase.statusDisplay }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          案件经过时间:
        </el-col>
        <el-col :span="17">{{ formCase.elapsed }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg" v-if="formCase.dlrQuality == formCase.dlrQualityOption[2]">
        <el-col :span="7">
          退回原因:
        </el-col>
        <el-col :span="17">{{ formCase.backReason }}</el-col>
      </el-row>
      <el-row type="flex" class="row-bg">
        <el-col :span="7">
          最终对应方案:
        </el-col>
        <el-col :span="17" v-html="finalSolution"></el-col>
      </el-row>
      <el-row class="row-bg" v-if="fileList.length>0">
        <el-col :span="24">
          附件 :
        </el-col>
        <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in fileList" :key="index">
          <img :src="item.url" preview="2" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
          <!-- <video :src="item.url" preload="auto" x5-playsinline style="width: 150px;height:150px;posiiton:relative;z-index:99999;"  x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" v-if="item.type&&item.type.indexOf('video')>=0"  webkit-playsinline="true" playsinline="true" controls></video> -->
          <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
            <div style="position:absolute;height:160px;width:100%;" >
              <video :src="item.url" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
              <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
            </div>
          </el-row>
          <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>
        </el-col>
      </el-row>
      <el-row v-if="!formCase.deliveryDateTimeMark&&user.type == 2&&formCase.status=='结案'">
        <el-col :span="7" style="line-height: 40px">
          交车时间 :
        </el-col>
        <el-col :span="17">
          <el-date-picker
            v-model="formCase.deliveryDateTime"
            type="datetime"
            value-format="yyyy-MM-ddTHH:mm:ss"
            placeholder="选择时间">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row v-if="formCase.deliveryDateTimeMark">
        <el-col :span="7">
          交车时间 :
        </el-col>
        <el-col :span="17">
          {{formCase.deliveryDateTime}}
        </el-col>
      </el-row>
      <el-form label-position="top" :rules="rules" ref="ruleForm" inlineMessage status-icon label-width="80px" :model="formCasedetail" >
        <el-form-item style="text-align: center;margin-top: 0.3rem">
          <el-button type="primary" style="margin-left:10px;" @click="commitTimeFn" v-show="!formCase.deliveryDateTimeMark&&user.type == 2 && jieanbtn == 3&&formCase.status=='结案'">提交交车时间</el-button>
          <el-button type="info" @click.native="cancels()">取消</el-button>
          <el-button type="primary" @click="relatedInfo" v-show="user.type == 1">对应</el-button>
          <router-link :to="'/newsChat/1/'+formCase.id" style="margin-left:10px;">
          <el-button type="primary" v-show="jieanbtn != 1" @click="chat(formCase.id)">消息</el-button>
          </router-link>
          <div style="line-height: 20px;float: right;"  v-show="user.type == 1">
            <img style="margin-top: 4px" title="未收藏" v-if="!formCase.favour" @click="collectionFn(formCase.id)" src="@/assets/images/collect.png" width="32px" alt="">
            <img style="margin-top: 4px" title="已收藏" v-if="formCase.favour" @click="collectionFn(formCase.id)" src="@/assets/images/collected.png" width="32px" alt="">
          </div>
          <el-button type="primary" style="margin-left:10px;" v-show="user.type == 2 && jieanbtn == 2 && formCase.statusDisplay == '退回'" @click="onReturn">确定退回</el-button>
          <el-button type="success" style="margin-left:10px;" @click="onSubmit" :disabled="finalSolution.length<1||sub" v-show="user.type == 2 && formCase.statusDisplay == '已提供最终方案'">结案</el-button>
          <el-button type="success" style="margin-left:10px;" @click="onSave" :disabled="sub" v-show="user.type == 2 && jieanbtn == 2 && formCase.statusDisplay == '处理中'">保存</el-button>
          <el-button type="success" style="margin-left:10px;" @click="renew" :disabled="sub" v-show="user.type == 2 && jieanbtn == 3&&formCase.statusDisplay=='已退回'">重新发起</el-button>
          <el-button type="success" style="margin-left:10px;" @click="renew" :disabled="sub" v-show="user.type == 2 && jieanbtn == 3&&formCase.statusDisplay=='结案'">再次发起</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </el-row>
</template>

<script>
import { uploadFile } from '@/api/file.js'
import axios from '@/utils/api.request'
import { searchCaseDetail, doneSubmit, dlrReturn, updateCase, getImg, getVideo, renewCase, caseFavour, commitDelivery } from '@/api/alarmCase'
import { Indicator, Toast, MessageBox } from 'mint-ui'
import Global from '@/config/global.js'

export default {
  data () {
    return {
      formCase: {
        id: 0,
        title: '', // 案件标题
        caseNo: '', // 案件编号
        caseType: '', // 案件类型
        vehicleType: '', // 车型型号
        vehicleCode: '', // 车型代码
        engineModel: '', // 发动机型号
        warrantyPeriod: '', // 三包状态
        kubun: '', // 类型//GR/钣金/喷漆
        vin: '', // vin
        createDatetime: '', // 数据创建时间
        offlineDate: '', // 下线日期
        doneDatetime: '', // 入库时间
        drivenDistance: '', // 行驶里程
        phenomenons: '', // 现象分类
        parts: '', // 现象分类表示名称
        dtcint: '', // DTC有无
        dtc: '', // dtc
        statusDisplay: '',
        userName: '',
        relayusername: '',
        complain: '', // CR苦情
        attachmentIds: [],
        dealerCode: '',
        dealerName: '', // DLR名
        type: 0, //  type 1:tcmi 2:dealer
        customerConsultation: '', // 顾客问诊
        phenomenonConfirmation: '', // 现象确认
        inspectionDiagnosis: '', // 检查诊断
        supportDiagnosis: '', // 请求支援内容
        doneStatus: '', // 结案状态
        startDatetime: '',
        dlrQualityOption: [],
        deliveryDateTime: null,
        deliveryDateTimeMark: null
      },
      formCasedetail: {
        id: 0,
        doneStatus: [], // 结案类型
        doneReason: '', // 原因描述
        doneSolution: '', // 维修方案
        dlrStatus: [], // 结案状态
        /*  customerConsultation: '', //顾客问诊
          phenomenonConfirmation: '', //现象确认
          inspectionDiagnosis: '', //检查诊断
          supportDiagnosis: '', //请求支援内容
          consultingContent: '', //咨询内容 */
        attachmentIds: [] // 图片列表
      },
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      partIdsArr: [],
      user: {},
      sub: false,
      jieanbtn: 0,
      doneStatusOption: [],
      dlrStatusOption: [],
      doneTypeOption: [],
      finalSolution: '',
      attachmentIdss: [],
      rules: {
        doneStatus: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        doneReason: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        doneSolution: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        dlrStatus: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    Indicator.open({
      text: '加载中...',
      spinnerType: 'fading-circle'
    })
    this.jieanbtn = this.$route.params.status
    this.user = JSON.parse(localStorage.getItem('user'))
    this.getDefault()
  },
  methods: {
    getDefault () {
      searchCaseDetail(this.$route.params.id).then(res => {
        this.formCase.id = res.data.id
        this.formCase.oldId = res.data.oldId
        this.formCasedetail.doneStatus = res.data.doneStatus
        this.formCasedetail.id = res.data.id
        this.formCasedetail.doneReason = res.data.doneReason
        this.formCasedetail.dlrStatus = res.data.dlrStatus
        this.formCasedetail.doneSolution = res.data.doneSolution
        this.formCasedetail.attachments = res.data.attachments
        this.formCase.dealerCode = res.data.dealerCode
        this.formCase.dealerName = res.data.dealerName
        this.formCase.type = res.data.type
        this.formCase.phenomenons = res.data.phenomenonCn
        this.formCase.parts = res.data.partCn
        this.formCase.engineModel = res.data.engineModel
        this.formCase.dtc = res.data.dtc
        this.formCase.statusDisplay = res.data.statusDisplay
        this.formCase.dtcint = res.data.dtcint
        this.formCase.complain = res.data.complain
        this.formCase.drivenDistance = res.data.drivenDistance
        this.formCase.offlineDate = res.data.offlineDate
        this.formCase.vin = res.data.vin
        this.formCase.kubun = res.data.kubun
        this.formCase.warrantyPeriod = res.data.warrantyPeriod
        this.formCase.vehicleCode = res.data.vehicleCode
        this.formCase.vehicleType = res.data.vehicleType
        this.formCase.title = res.data.title
        this.formCase.status = res.data.status
        this.formCase.customerConsultation = res.data.customerConsultation
        this.formCase.phenomenonConfirmation = res.data.phenomenonConfirmation
        this.formCase.inspectionDiagnosis = res.data.inspectionDiagnosis
        this.formCase.supportDiagnosis = res.data.supportDiagnosis
        this.formCase.doneDatetime = res.data.doneDatetime
        this.formCase.caseNo = res.data.caseNo
        this.formCase.userName = res.data.userName
        this.formCase.relayusername = res.data.relayusername
        this.doneStatusOption = res.data.doneStatusOption
        this.dlrStatusOption = res.data.dlrstatusOption
        this.formCase.startDatetime = res.data.startDatetime
        this.formCase.dlrQuality = res.data.dlrQuality
        this.formCase.dlrQualityOption = res.data.dlrQualityOption
        this.formCase.backReason = res.data.backReason
        this.formCase.elapsed = res.data.elapsed
        this.formCase.doneDate = res.data.doneDate
        this.formCase.finalSolutionDate = res.data.finalSolutionDate
        this.formCase.favour = res.data.favour
        this.formCase.deliveryDateTime = res.data.deliveryDateTime
        this.formCase.deliveryDateTimeMark = res.data.deliveryDateTime
        // this.formCase.finalSolution = res.data.finalSolution
        var arrfin = res.data.finalSolution ? res.data.finalSolution.split(',') : []
        this.finalSolution = ''
        arrfin.forEach(v => {
          if (v && v.indexOf('attachments/') > -1) {
            getImg(v).then(resp => {
              var mimeType = 'image/jpeg'
              var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
              v = 'data:' + mimeType + ';base64,' + imgBase64
              this.finalSolution += `<img src="${v}" width="100px" height="50px" onerror="this.src='../assets/images/timg.jfif'" alt="图片资源丢失">`
            }).then(() => {
              this.formCase.finalSolution = this.finalSolution
            })
          } else {
            this.formCase.finalSolution += v
            this.finalSolution += v
          }
        })
        if (res.data.attachments) {
          res.data.attachments.forEach((v, i) => {
            let json = {
              id: v.id,
              name: v.rawName,
              url: v.url,
              type: v.mime
            }
            this.fileList.push(json)
            if (v.mime.indexOf('image') >= 0) {
              getImg(v.url).then(resp => {
                var mimeType = v.mime.toLowerCase()
                var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
                this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64
              })
            } else if (v.mime.indexOf('video') >= 0) {
              this.fileList[i].url = Global.server_api + v.url
            }
          })
        }
        Indicator.close()
      })
    },
    collectionFn (id) {
      caseFavour(id).then(res => {
        Toast({
          message: this.formCase.favour ? '取消收藏' : '收藏成功',
          iconClass: 'icon el-icon-check'
        })
        this.getDefault()
      })
    },
    onReturn () {
      dlrReturn(this.formCase.id).then(res => {
        if (res.data.success) {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
        } else {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
        this.$router.push('/case')
      })
    },
    commitTimeFn() {
      commitDelivery(this.formCase.id, this.formCase.deliveryDateTime).then(res => {
        console.log(res)
        if (res.data.area) {
          Toast({
            message: '提交交车时间成功',
            iconClass: 'icon el-icon-check'
          })
          this.getDefault()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    renew () {
      renewCase(this.formCase.id, this.formCase.oldId).then(res => {
        if (res.data.success) {
          Toast({
            message: '再次发起案件',
            iconClass: 'icon el-icon-check'
          })
        } else {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
        this.$router.push({ path: '/addedCase/0', query: res.data.data })
      })
    },
    scale (e) {
      if (e.target.style.position == 'fixed') {
        e.target.style.position = 'static'
        e.target.style.height = '100%'
      } else {
        e.target.style.position = 'fixed'
        e.target.style.top = '0'
        e.target.style.bottom = 0
        e.target.style.marginTop = 'auto'
        e.target.style.marginBottom = 'auto'
        e.target.style.left = 0
        e.target.style.zIndex = '1000'
        e.target.style.height = 'auto'
        e.target.style.transition = '1s'
      }
    },
    chat (e) {
      var status = 1
      this.$router.push({ path: '/newsChat/' + status + '/' + e })
    },
    onSubmit () {
      MessageBox.confirm('', {
        title: '提示',
        message: '结案后无法撤回，确认结案?',
        showCancelButton: true
      }).then(() => {
        doneSubmit(this.formCasedetail).then(res => {
          if (res.data.success) {
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-check'
            })
            this.$router.push('/case')
          } else {
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-close'
            })
          }
        })
      })
    },
    onSave () {
      console.log(this.attachmentIdss)
      this.formCasedetail.attachmentIds = []
      this.attachmentIdss.forEach((v, i) => {
        this.formCasedetail.attachmentIds.push(v.id)
      })
      updateCase(this.formCasedetail.id, this.formCasedetail).then(res => {
        if (res.data.success) {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.$router.push('/case')
        } else {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
      this.sub = true
      setTimeout(() => {
        this.sub = false
      }, 3000)
    },
    cancels () {
      this.$router.go(-1)
    },
    relatedInfo () {
      this.$router.push({ path: '/relatedinfo/' + this.$route.params.id })
    }
  }
}
</script>

<style scoped>
  .el-button {
    margin-bottom: 10px;
  }
  .el-form-item {
    text-align: left;
    margin-top: 0.3rem;
  }
  .el-form-item__label {
    line-height: 0.4rem;
  }
  .container {
    max-width: 500px;
    margin:auto;
    background: #fff;
  }
  .el-col{
    padding:0;
    text-align: left;
    overflow:hidden;
  }
  .el-row{
    padding:0;
    margin-bottom: 0.1rem;
  }
  .content{
    padding:0 0.32rem;
  }
  .el-upload-list--picture-card .el-upload-list__item,div.el-upload--picture-card{
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
  }
  .el-radio.is-bordered+.el-radio.is-bordered{
    margin-left: 0;
  }
  .el-radio{
    margin-right: 3%;
    margin-bottom: 15px;

  }
  .picture, video {
    width: 100%;
    height: 150px;
    display: inline-block;
  }
</style>
